
<app-user></app-user>
	
<jaspero-confirmations></jaspero-confirmations>
<ng4-loading-spinner [threshold]="2000"  [loadingText]="'Please wait...'" [zIndex]="9999"> </ng4-loading-spinner>



